exports.ACTIVE = 'Active';
exports.SUSPENDED = 'Suspended';
exports.PAYMENT_FAILED = 'Payment Failed';
exports.CANCELED = 'Cancelled';
exports.PENDING_ACTIVATION = 'Pending Activation';
exports.IN_TRIAL = 'In Trial';
exports.DISPUTED = 'Disputed';
exports.COMMISSION_ONLY = 'Commission Only';